module.exports = __webpack_public_path__ + "static/media/ivan.cfc2b2aa.png";